import apiFetch from '../../apiFetch'

export default function (dossierId, token, lastAccessDate) {
  return apiFetch({ endPoint: `dossier/${dossierId}/TransferCompleted`, method: 'PUT', body: null, token: token, lastAccessDate })
}
